module.exports = __webpack_public_path__ + "static/photo-hosting-18a99c2b4acfa5346e17f2ab7a63aa41.webp";